import { HTTP } from '../../utils'

export const getAllQuickLinksForInstitution = () => {
  return HTTP().get('quicklink')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const createOrUpdateQuickLink = (quickLink) => {
  var url = 'quicklink/'
  if (quickLink.uuid) {
    url += quickLink.uuid
  }
  return HTTP().put(url, quickLink)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteMultipleQuickLinks = (uuids) => {
  return HTTP().delete('quicklink/multiple?uuids=' + uuids)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/quickLink/api.js